// ─────────────────────────────────────────────────────────
// Einstellungen → Layout & Textvorlagen → WhatsApp-Text
// ─────────────────────────────────────────────────────────
// Der Begleittext, der beim Kunden neben dem Dokument-Link steht.
// Prefix wt-. Rechte: layout:read / layout:write.
//
// DIE EINE REGEL, DIE MAN HIER NICHT BRECHEN DARF: die Felder werden NICHT mit
// dem Standardtext vorbefüllt. Der Standard liegt in 14 Dokumentsprachen
// fertig vor; ein «Speichern» ohne Änderung würde ihn still gegen eine einzige
// Sprache eintauschen. Darum steht er nur als GRAUER Beispieltext im Feld
// (placeholder) — sichtbar, aber nicht gespeichert. Wer ihn als Grundlage
// will, holt ihn sich mit «Standardtext einsetzen».
import { icon, escapeHtml } from '../../utils/dom.js';
import { saveWhatsappTextSettings } from '../../core/org.js';
import { t } from '../../i18n/index.js';

// Nur die Schlüssel — Beschriftung aus settings.whatsappText.ph.*
const PLACEHOLDERS = ['client', 'number', 'type', 'date', 'link', 'sender', 'company'];

function data(s) {
  return s.whatsappText || {};
}

export function whatsappTextHeadButton(ctx) {
  if (!ctx.can('layout:write')) return '';
  const saving = ctx.s.wtSaving;
  return `<button class="cd-btn-primary" data-action="wt-save" ${saving ? 'disabled' : ''}>${escapeHtml(saving ? t('common.saving') : t('common.save'))}</button>`;
}

export function renderWhatsappTextSection(ctx) {
  const { s, can } = ctx;
  if (!can('layout:read')) return `<div class="cd-set-empty">${escapeHtml(t('common.noPermission'))}</div>`;

  const d = data(s);
  const v = d.whatsappDefaults || {};
  const ex = d.examples || {};
  const dis = s.wtSaving || !can('layout:write') ? 'disabled' : '';
  const chips = PLACEHOLDERS.map(
    (k) => `<code class="cd-fn-chip" title="${escapeHtml(t('settings.whatsappText.ph.' + k))}">${escapeHtml('{' + k + '}')}</code>`,
  ).join('');

  const feld = (id, labelKey, value, beispiel) => `
    <div class="cd-dt-field">
      <div class="cd-wt-caprow">
        <label class="cd-dt-cap" for="${id}">${escapeHtml(t(labelKey))}</label>
        ${can('layout:write')
          ? `<button class="cd-btn-ghost cd-btn-sm" data-action="wt-fill" data-target="${id}">${escapeHtml(t('settings.whatsappText.insertDefault'))}</button>`
          : ''}
      </div>
      <textarea class="cd-input cd-dt-area" id="${id}" rows="10" maxlength="5000"
        placeholder="${escapeHtml(beispiel || '')}" ${dis}>${escapeHtml(value || '')}</textarea>
    </div>`;

  return `
    <div class="cd-emp">
      <div class="cd-emp-card">
        <div class="cd-emp-card-head">${icon('chat', 18)}<h3>${escapeHtml(t('settings.whatsappText.title'))}</h3></div>
        <p class="cd-sc-lead">${escapeHtml(t('settings.whatsappText.lead'))}</p>
        ${feld('wt-offer', 'settings.whatsappText.offer', v.offerText, ex.offerText)}
        ${feld('wt-invoice', 'settings.whatsappText.invoice', v.invoiceText, ex.invoiceText)}
        <div class="cd-fn-ph">
          <span class="cd-nr-cap">${escapeHtml(t('settings.whatsappText.placeholders'))}</span>
          <div class="cd-fn-chips">${chips}</div>
        </div>
      </div>
      <div class="cd-emp-info cd-sc-note">${icon('info', 18)}<span>${escapeHtml(t('settings.whatsappText.note'))}</span></div>
    </div>`;
}

export function handleWhatsappTextAction(a, el, ctx) {
  const { s, draw, reload } = ctx;

  // «Standardtext einsetzen» — holt den grauen Beispieltext ins Feld, damit
  // man ihn abwandeln statt abtippen kann. Ab dann ist es ein eigener Text.
  if (a === 'wt-fill') {
    if (!ctx.can('layout:write')) return true;
    const ta = document.getElementById(el.getAttribute('data-target'));
    if (ta && ta.placeholder) ta.value = ta.placeholder;
    return true;
  }

  if (a !== 'wt-save') return false;
  if (!ctx.can('layout:write')) return true;
  const val = (id) => (document.getElementById(id)?.value || '').slice(0, 5000);
  const payload = { offerText: val('wt-offer'), invoiceText: val('wt-invoice') };
  s.wtSaving = true; draw();
  saveWhatsappTextSettings(payload)
    .then(() => { s.wtSaving = false; if (reload) reload(); else draw(); })
    .catch((err) => { s.wtSaving = false; s.error = err.message || t('common.saveFailed'); draw(); });
  return true;
}
